export const FieldsBasicPlaceDetails = [
  'address_component',
  'geometry',
  'formatted_address',
  'name',
  'place_id',
  'type',
];
